export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/Discover/theme/components/scorecard/MetricsLabels/index.js